import { Component, OnInit } from '@angular/core';
import { routeAlias } from '../../../../../routesalias';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { closeLocalStorage } from '../../../../utils/helpers';
import { OngletlayoutComponent } from '../../../../components/layouts/ongletlayout/ongletlayout.component';

@Component({
  selector: 'app-marches',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './marches.component.html',
  styleUrl: './marches.component.css'
})
export class MarchesLayoutComponent {

  constructor(
    private router: Router,
  ) { }

  public isClicked: boolean = false;

  onClickMenu(): void {
    this.isClicked = !this.isClicked;
  }

  onCloseLocalStorage(): void {
    closeLocalStorage();
    this.onClickMenu();
  }

  tableLinkForMarche = [
    {
      text: "Type de mode de passation",
      link: routeAlias.parameters.marches.type_mode_passation.home,
    },
    {
      text: "Source de Financements",
      link: routeAlias.parameters.marches.financements.home,
    },
    {
      text: "Mode de passation de marche",
      link: routeAlias.parameters.marches.mode_passation_marches.home,
    },
  ]
}
